import React, { useEffect, useState } from "react";

import { Divider, Input, Select, Spin, Tabs, notification } from "antd";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { LoadingOutlined } from "@ant-design/icons";
import NumberFormat from "react-number-format";
import * as yup from "yup";

import "swiper/css";

import _1 from "../../../../assets/_1.jpg";

import { ReactComponent as ArrowLeftIcon } from "../../../../assets/images/icons/arrow-left.svg";
import { ReactComponent as NotificationIcon } from "../../../../assets/images/icons/mobilenotification.svg";
import {
  _complete_bank_transfer,
  _complete_user_paybill,
  _confirm_user_transfer_pin,
  _fetch_bank_list,
  _fetch_bill_options,
  _fetch_user_data_options,
  _fetch_user_meter_data,
  _fund_user_wallet,
} from "../../../../common/axios_services";
import AppRoutes from "../../../../common/routes";
import FooterDisplay from "../../../../components/footer";

import MtnImg from "../../../../assets/images/bill_logos/mtn.jpg";
import NtelImg from "../../../../assets/images/bill_logos/ntel.svg";
import GloImg from "../../../../assets/images/bill_logos/glo.png";
import MobileImg from "../../../../assets/images/bill_logos/9mobile.png";
import AirtelImg from "../../../../assets/images/bill_logos/airtel.png";
import { yupResolver } from "@hookform/resolvers/yup";
import RequestTransactionCode from "../../../../components/profile/transcode";

const TVPage = () => {
  const Navigate = useNavigate();

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#fff" }} spin />
  );
  const subAntIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#0D60D8" }} spin />
  );
  const antPageIcon = (
    <LoadingOutlined style={{ fontSize: 35, color: "#0D60D8" }} spin />
  );

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: "",
      description: message,
    });
  };

  const digitsOnly = (value) => /^\d+$/.test(value);
  // AIRTIME PURCHASE STARTS

  const checkAirtimeData = yup.object().shape({
    // amount: yup.string().required('Please select provider'),
    iuc_number: yup
      .string()
      .required("Please enter meter number")
      .min(10, "Please enter a valid meter number")
      .max(10, "Please enter a valid meter number")
      .test("Digits only", "The field should have digits only", digitsOnly),
    packages: yup.string().required("Please select package"),
    phone: yup
      .string()
      .min(9, "Please enter a valid phone number")
      .required("Phone number field is required")
      .test("Digits only", "The field should have digits only", digitsOnly),
  });
  // start form handlers
  const [searchParam] = useSearchParams();

  const {
    handleSubmit: handleAirtimePayment,
    control: controlAirtimePayment,
    watch,
    getValues,
    setValue,
    formState: { errors: errorAirtime },
  } = useForm({
    resolver: yupResolver(checkAirtimeData),
  });
  const [loadingData, setLoadingData] = useState(false);
  const [loadingPageData, setLoadingPageData] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [userElectricityAmount, setUserElectricityAmount] = useState(0);
  const [, setUserTransPin] = useState("");
  const [displayTransCodeModal, setDisplayTransCodeModal] = useState(false);
  const [billType] = useState("television");
  const [providerOption, setProviderOption] = useState([]);
  const [electricityData, setElectricityData] = useState({});
  const [selectedBillProvider, setSelectedBillProvider] = useState("");
  const [electricityPackages, setElectricityPackages] = useState([]);
  const [electricityUserInfo, setElectricityUserInfo] = useState({});
  const [loadingMeterData, setLoadingMeterData] = useState(false);
  const [tvAmount, setTVAmount] = useState("");

  // fund user wallet amount
  const onChangeValue = (e) => {
    let amount = 0;
    if (e.target.value.includes("NGN")) {
      amount = e.target.value.split(" ")[1]?.split(",").join("");
    } else {
      amount = e.target.value;
    }
    setUserElectricityAmount(amount);
  };

  // user transfer
  const navigate = useNavigate();

  /* finalize pay bill */
  const finalizeTVPayment = async (e) => {
    setLoadingData(true);
    setErrorMessage("");
    try {
      let data = {
        amount: tvAmount,
        smartcard_number: getValues("iuc_number"),
        phone_number: electricityData.phoneNumber,
        product_slug: getValues("packages").split("---")[0],
        provider: selectedBillProvider,
      };

      const profile = await _complete_user_paybill("buy_television", data);
      if (profile.data.status === "success") {
        openNotificationWithIcon("success", "TV plan purchase successful");
        Navigate(AppRoutes.wallet);
      } else {
        openNotificationWithIcon("error", profile.data.message);
        setLoadingData(false);
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          navigate("/signin");
        } else {
          openNotificationWithIcon("error", err?.response?.data?.message);
        }
      } else if (err?.code === "ERR_NETWORK") {
        openNotificationWithIcon(
          "error",
          "An error occurred while completing transaction. Please check network and try again."
        );
      } else {
        openNotificationWithIcon(
          "error",
          "An error occurred while completing transaction. Please reload page to try again."
        );
      }
      setLoadingData(false);
    }
  };

  const fetchElectricityProviders = async () => {
    setLoadingPageData(true);
    setErrorMessage("");
    try {
      const profile = await _fetch_bill_options(billType);
      if (profile.data.status === "success") {
        setProviderOption(profile.data.data);
      } else {
        openNotificationWithIcon("error", profile.data.message);
      }
      setLoadingPageData(false);
    } catch (err) {
      if (err?.response?.data?.message) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          navigate("/signin");
        } else {
          openNotificationWithIcon("error", err?.response?.data?.message);
        }
      } else if (err?.code === "ERR_NETWORK") {
        openNotificationWithIcon(
          "error",
          "An error occurred while fetching data. Please check network and try again."
        );
      } else {
        openNotificationWithIcon(
          "error",
          "An error occurred while fetching data. Please reload page to try again."
        );
      }
      setLoadingPageData(false);
    }
  };

  const controlTransCodeModalDisplay = () =>
    setDisplayTransCodeModal(!displayTransCodeModal);

  useEffect(() => {
    fetchElectricityProviders();
  }, []);

  const fetchElectricityPlans = async (billDataInfo) => {
    setLoadingPageData(true);
    setErrorMessage("");
    try {
      const profile = await _fetch_user_data_options(billDataInfo);
      if (profile.data.status === "success") {
        setElectricityPackages(profile.data.data);
      } else {
        openNotificationWithIcon("error", profile.data.message);
      }
      setLoadingPageData(false);
    } catch (err) {
      if (err?.response?.data?.message) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          navigate("/signin");
        } else {
          openNotificationWithIcon("error", err?.response?.data?.message);
        }
      } else if (err?.code === "ERR_NETWORK") {
        openNotificationWithIcon(
          "error",
          "An error occurred while fetching data. Please check network and try again."
        );
      } else {
        openNotificationWithIcon(
          "error",
          "An error occurred while fetching data. Please reload page to try again."
        );
      }
      setLoadingPageData(false);
    }
  };

  const updateUserBillProvider = (e) => {
    fetchElectricityPlans(e.split("---")[1]);
    setSelectedBillProvider(e.split("---")[1]);
  };

  const fetchUserMeterData = async () => {
    setLoadingMeterData(true);
    setErrorMessage("");
    try {
      let slug = getValues("packages").split("---")[0];
      const profile = await _fetch_user_meter_data(
        slug,
        getValues("iuc_number")
      );
      if (profile.data.status === "success") {
        setElectricityUserInfo(profile?.data?.data?.attributes);
      } else {
        openNotificationWithIcon("error", profile.data.message);
      }
      setLoadingMeterData(false);
    } catch (err) {
      if (err?.response?.data?.message) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          navigate("/signin");
        } else {
          openNotificationWithIcon("error", err?.response?.data?.message);
        }
      } else if (err?.code === "ERR_NETWORK") {
        openNotificationWithIcon(
          "error",
          "An error occurred while fetching data. Please check network and try again."
        );
      } else {
        openNotificationWithIcon(
          "error",
          "An error occurred while fetching data. Please reload page to try again."
        );
      }
      setLoadingMeterData(false);
    }
  };

  useEffect(() => {
    if (
      getValues("iuc_number")?.length === 10 &&
      getValues("packages") &&
      selectedBillProvider
    ) {
      fetchUserMeterData();
    }
  }, [watch("iuc_number"), watch("packages")]);

  useEffect(() => {
    // setValue("amount",)
    if (getValues("packages")) {
      let val = getValues("packages").split("---")[2];
      // console.log(val);
      // console.log(val.slice(0, val.length - 2));
      setValue("amount", `NGN ${val.slice(0, val.length - 2)}`);
      // setElectricityData({
      //     ...electricityData,
      //     amount: +val.slice(0, val.length - 2)
      // })
      setTVAmount(val.slice(0, val.length - 2));
    }
  }, [watch("packages")]);

  // AIRTIME PURCHASES ENDS

  // confirm user transaction pin
  const handleBillPaymentForm = (e) => {
    setElectricityData({
      amount: userElectricityAmount,
      phone_number: e.phone,
      provider: selectedBillProvider,
    });
    controlTransCodeModalDisplay();
  };

  const checkUserPin = async (e) => {
    setLoadingData(true);
    controlTransCodeModalDisplay();
    setLoadingPageData(true);
    try {
      const profile = await _confirm_user_transfer_pin(e);
      if (profile.data.status === "success") {
        finalizeTVPayment();
      } else {
        setLoadingData(false);
        setLoadingPageData(false);
        openNotificationWithIcon(
          "error",
          "An error occurred while completing transaction. Please check network and try again"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          navigate("/signin");
        } else {
          openNotificationWithIcon("error", err?.response?.data?.message);
        }
      } else if (err?.code === "ERR_NETWORK") {
        openNotificationWithIcon(
          "error",
          "An error occurred while completing transaction. Please check network and try again."
        );
      } else {
        openNotificationWithIcon(
          "error",
          "An error occurred while completing transaction. Please reload page to try again."
        );
      }
      setLoadingData(false);
      setLoadingPageData(false);
    }
  };

  return (
    <Spin spinning={loadingPageData} indicator={antPageIcon}>
      <div className="display-page bills">
        <div className="small-page-title contain">
          <div className="grid-flex">
            <div onClick={() => Navigate(-1)}>
              <ArrowLeftIcon />
            </div>
            <div>
              <h3 className="sec-page-title">Pay Bills</h3>
            </div>
            <div>
              <NotificationIcon />
            </div>
          </div>
        </div>
        <div className="display-main-content mt_3">
          <div className="hero-sect">
            <div className="container">
              <p className="form-explanation">
                All financial details are stored to PCIDSS level 1 and
                transmitted via an encrypted 256-bit Https SSL connection.
              </p>
              <div>
                <div className="mt_5">
                  <div>
                    {errorMessage.length ? (
                      <p className="form-error mb_3">{errorMessage}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <form onSubmit={handleAirtimePayment(handleBillPaymentForm)}>
                    <div className="form_group">
                      <div className="grid-flex">
                        <label>Select Provider</label>
                      </div>
                      <Controller
                        name="provider"
                        control={controlAirtimePayment}
                        render={({ field }) => (
                          <Select
                            {...field}
                            style={{ height: "5rem", width: "100%" }}
                            onChange={updateUserBillProvider}
                          >
                            {providerOption.map((provider, index) => (
                              <Select.Option
                                key={index}
                                value={`${provider?.attributes?.name}---${provider?.id}`}
                              >
                                <div className="bill-inline">
                                  {provider.attributes.name}
                                </div>
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                      />
                      {errorAirtime.provider && (
                        <p className="form-error">
                          {errorAirtime.provider.message}
                        </p>
                      )}
                    </div>
                    <div className="form_group">
                      <div className="grid-flex">
                        <label>Package</label>
                      </div>
                      <Controller
                        name="packages"
                        control={controlAirtimePayment}
                        render={({ field }) => (
                          <Select
                            {...field}
                            style={{ height: "5rem", width: "100%" }}
                          >
                            {electricityPackages.map((provider, index) => (
                              <Select.Option
                                key={index}
                                value={`${provider?.attributes?.slug}---${provider?.id}---${provider?.attributes?.price?.minimumAmount}`}
                              >
                                <div className="bill-inline">
                                  {provider.attributes.name}
                                </div>
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                      />
                      {errorAirtime.packages && (
                        <p className="form-error">
                          {errorAirtime.packages.message}
                        </p>
                      )}
                    </div>
                    <div className="form_group">
                      <div className="grid-flex">
                        <label>IUC Number</label>
                        {loadingMeterData ? (
                          <Spin indicator={subAntIcon} />
                        ) : (
                          ""
                        )}
                      </div>
                      <Controller
                        name="iuc_number"
                        control={controlAirtimePayment}
                        render={({ field }) => (
                          <Input
                            name="iuc_number"
                            {...field}
                            type="tel"
                            style={{ height: "5rem", width: "100%" }}
                          />
                        )}
                      />
                      {errorAirtime.iuc_number && (
                        <p className="form-error">
                          {errorAirtime.iuc_number.message}
                        </p>
                      )}
                      {electricityUserInfo && (
                        <p>{electricityUserInfo.customerName}</p>
                      )}
                    </div>
                    <div className="form_group">
                      <div className="grid-flex">
                        <label>Amount</label>
                        <p>0% charge</p>
                      </div>
                      <Controller
                        name="amount"
                        control={controlAirtimePayment}
                        render={({ field }) => (
                          <Input
                            name="amount"
                            {...field}
                            type="number"
          inputMode="numeric"
                            disabled
                            style={{ height: "5rem", width: "100%" }}
                          />
                          // <NumberFormat thousandSeparator={true}
                          //     prefix={'NGN '}
                          //     className="numeric"
                          //     onInput={e => onChangeValue(e)}
                          //     {...field} style={{ height: '5rem', width: '100%' }} />
                        )}
                      />
                      {errorAirtime.amount && (
                        <p className="form-error">
                          {errorAirtime.amount.message}
                        </p>
                      )}
                    </div>
                    <div className="form_group">
                      <div className="grid-flex">
                        <label>Phone number</label>
                      </div>
                      <Controller
                        name="phone"
                        control={controlAirtimePayment}
                        render={({ field }) => (
                          <Input
                            type="tel"
                            {...field}
                            style={{ height: "5rem", width: "100%" }}
                          />
                        )}
                      />
                      {errorAirtime.phone && (
                        <p className="form-error">
                          {errorAirtime.phone.message}
                        </p>
                      )}
                    </div>
                    <div className="welcome-buttons mt_20">
                      <div className="welcome-buttons-content">
                        {!loadingData ? (
                          <button
                            // disabled={userElectricityAmount > 0 ? false : true}
                            className="btn btn-primary"
                          >
                            Continue
                          </button>
                        ) : (
                          <button className="btn-primary" disabled>
                            <Spin indicator={antIcon} />
                          </button>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <RequestTransactionCode
              openDrawer={displayTransCodeModal}
              closeDrawer={controlTransCodeModalDisplay}
              inputCount={4}
              actionFunction={checkUserPin}
              stateFunc={setUserTransPin}
            />
          </div>
          <FooterDisplay />
        </div>
      </div>
    </Spin>
  );
};

export default TVPage;
